import ContentPageContainer from "components/molecules/common/ContentPageContainer"
import useTranslations from "../hooks/useTranslations"

const NotFoundPage = () => {
  const { page404Title, page404Description } = useTranslations()
  return (
    <ContentPageContainer title={page404Title}>
      <p className="m-0 text-zinc-800">{page404Description}</p>
    </ContentPageContainer>
  )
}

export default NotFoundPage
